import { DialogService, GridAction } from '@eforall/dashboard';
import { AccApplicationWithSortingScore } from '@interfaces';
import { AccApplicationDialog, AssignedStaffDialog, AssignedStaffDialogResult, PersonDialog } from '../../../../../../ui/widget';
import { AdmissionsAreaService } from '../../../../admissions-area.service';


export function getActions(dialogService: DialogService, admissionsAreaService: AdmissionsAreaService) {

	const actions: GridAction<AccApplicationWithSortingScore>[] = [
		{
			iconClass: 'fa-regular fa-file-lines',
			label: 'Open Application Details',
			isEnabled: rows => !!rows.length,
			execute: async rows => {
				await dialogService.showCustom(AccApplicationDialog, { data: { accApplicationId: rows[0]!.accApplicationId } }, 900, 900);
				await admissionsAreaService.reloadData(); // TODO fix this to only call if there are changes
			}
		},
		{
			iconClass: 'fa-regular fa-user',
			label: 'Explore Person',
			isEnabled: rows => !!rows.length,
			execute: async rows => {
				await dialogService.showCustom(PersonDialog, { data: { personId: rows[0]!.personId, toEdit: false } }, 800, 800);
			}
		},
		{
			iconClass: 'fa-regular fa-user-gear',
			label: 'Assign Staff Member',
			isEnabled: rows => {
				if (admissionsAreaService.canManageAdmissionsStaff()) return !!rows.length;
				return false;
			},
			execute: async rows => {
				const ventureName = rows[0]?.ventureName;
				const staffId = rows[0]?.assignedToStaffId || 0;
				const action = await dialogService.showCustom(AssignedStaffDialog, {
					data: {
						headerText: ventureName!,
						staffId: staffId
					}
				}, 800, 300);

				const result = action?.callbackResult as AssignedStaffDialogResult | undefined;
				if (result) {
					await admissionsAreaService.updateAssignedStaffForApplication(rows[0]!.accApplicationId, result.staffId);
					await admissionsAreaService.reloadData();
				}
			}
		},
	];

	return actions;
}
